// Decorations API Client
// Handles decoration equipment management

import { apiClient } from './client';

export type SlotType = 'card_image_deck' | 'card_back' | 'background';

export interface EquippedDecoration {
  itemId: number;
  name: string;
  filePath: string;
  isAnimated?: boolean;
}

export interface EquippedDecorations {
  cardImageDeck: string | null;
  cardBack: EquippedDecoration | null;
  background: EquippedDecoration | null;
}

export interface EquipDecorationRequest {
  slotType: SlotType;
  itemId?: number;  // Required for card_back and background
  deckId?: string;  // Required for card_image_deck
}

export interface UnequipDecorationRequest {
  slotType: SlotType;
}

export interface EquippedDecorationsResponse {
  success: boolean;
  data: {
    equipped: EquippedDecorations;
  };
}

export interface EquipDecorationResponse {
  success: boolean;
  data: {
    slotType: SlotType;
    itemId: number | null;
    deckId: string | null;
  };
  message: string;
}

export interface UnequipDecorationResponse {
  success: boolean;
  data: {
    slotType: SlotType;
  };
  message: string;
}

export const decorationsAPI = {
  /**
   * GET /api/decorations/equipped
   * Get user's currently equipped decorations
   */
  getEquipped: async (): Promise<EquippedDecorationsResponse> => {
    return await apiClient.get('/api/decorations/equipped');
  },

  /**
   * POST /api/decorations/equip
   * Equip a decoration to a slot
   */
  equip: async (data: EquipDecorationRequest): Promise<EquipDecorationResponse> => {
    return await apiClient.post('/api/decorations/equip', data);
  },

  /**
   * POST /api/decorations/unequip
   * Unequip a decoration from a slot
   */
  unequip: async (data: UnequipDecorationRequest): Promise<UnequipDecorationResponse> => {
    return await apiClient.post('/api/decorations/unequip', data);
  }
};
